import actionTypes from './actionTypes';

const INITIAL_STATE = {
  createGiftChairsLoading: false,
  createGiftChairsFailed: false,
  createGiftChairsError: false,
  createGiftChairsMessage: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.CREATE_GIFT_CHAIRS_LOADING: {
      return {
        ...state,
        createGiftChairsLoading: true,
        createGiftChairsFailed: false,
        createGiftChairsError: false,
        createGiftChairsMessage: null,
      };
    }
    case actionTypes.CREATE_GIFT_CHAIRS_SUCCESS: {
      return {
        ...state,
        createGiftChairsLoading: false,
        createGiftChairsFailed: false,
        createGiftChairsError: false,
        createGiftChairsMessage: null,
      };
    }
    case actionTypes.CREATE_GIFT_CHAIRS_REJECT: {
      return {
        ...state,
        createGiftChairsLoading: false,
        createGiftChairsFailed: false,
        createGiftChairsError: true,
        createGiftChairsMessage: null,
      };
    }
    case actionTypes.CREATE_GIFT_CHAIRS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        createGiftChairsLoading: false,
        createGiftChairsFailed: true,
        createGiftChairsError: false,
        createGiftChairsMessage: message,
      };
    }

    default:
      return state;
  }
};